function fillRemainingHeight(_) {
  return {
    restrict: 'A',
    link($scope, $element) {
      const el = $element[0];

      function adjustHeight() {
        el.style.height = `${window.innerHeight - el.offsetTop}px`;
      }

      // do initial resize
      setTimeout(() => {
        adjustHeight();
      }, 200);

      const onResize = _.debounce(() => {
        adjustHeight();
      }, 300);

      const windowElement = angular.element(window).on('resize',
        onResize
      );

      $scope.$on('$destroy', () => {
        windowElement.off('resize', onResize);
      });
    }
  };
}

const directiveArr = [
  '_',
  fillRemainingHeight
];

export default function (ngModule) {
  ngModule.directive('fillRemainingHeight', directiveArr);
}
